import { motion } from "framer-motion";

export const HeroAudienceToggle = ({ audience, onChange }) => (
  <motion.div
    initial={{ opacity: 0, y: -10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.15, duration: 0.6 }}
    data-testid="hero-audience-toggle"
    className="inline-flex items-center gap-1 bg-white/10 border border-white/20 rounded-full p-1 mb-5 ml-2"
  >
    <button
      onClick={() => onChange("drivers")}
      data-testid="hero-audience-driver-tab"
      className={`px-4 py-1.5 rounded-full text-xs font-bold transition-colors ${
        audience === "drivers" ? "bg-white text-rr-navy" : "text-white/70 hover:text-white"
      }`}
    >
      For Drivers
    </button>
    <button
      onClick={() => onChange("carriers")}
      data-testid="hero-audience-carrier-tab"
      className={`px-4 py-1.5 rounded-full text-xs font-bold transition-colors ${
        audience === "carriers" ? "bg-white text-rr-navy" : "text-white/70 hover:text-white"
      }`}
    >
      For Carriers
    </button>
  </motion.div>
);
